<template>
  <div>
    <role-form
      :role="role"
      :submit="submit"
    />
  </div>
</template>

<script>
import RoleForm from '@/components/TeamManagement/Roles/RoleForm.vue'
import Roles from '@/compositions/TeamManagement/Roles/RolesAPI'
import handleAlerts from '@/compositions/common/handleAlerts'

export default {
  name: 'EditRole',
  components: { RoleForm },
  setup() {
    const { successfulOperationAlert } = handleAlerts()
    const { role, showRequest, updateRequest } = Roles()
    return {
      role, showRequest, updateRequest, successfulOperationAlert,
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    getRole() {
      this.showRequest(this.$route.params.id).then(res => {
        this.role = { ...res.data.data, permissions: res.data.data.permissions?.map(permission => permission.id) }
      })
    },
    submit() {
      return this.updateRequest().then(() => {
        this.successfulOperationAlert('Role is updated successfully')
        this.$router.back()
      })
    },
  },
}
</script>

<style>

</style>
